import { svg } from "lit";
const icon = svg `<path d="M14.4001 12.9996C14.4001 14.3251 13.3256 15.3996 12.0001 15.3996C10.6746 15.3996 9.6001 14.3251 9.6001 12.9996C9.6001 11.6741 10.6746 10.5996 12.0001 10.5996C13.3256 10.5996 14.4001 11.6741 14.4001 12.9996Z" fill="currentColor"/>`;
export default icon;
